<template>
    <div>
        <div>
            <div class="row">
                <div class="col-sm-12 col-lg-7">
                    <div
                        class="sau-bx px-2 d-flex align-items-center order-2 order-lg-1"
                        style="min-height:220px;"
                    >
                        <div class="row w-100">
                            <div class="col text-center">
                                <div v-show="!this.gotData">
                                    <p class="sau-pm-reset mb-4">Retrieving Credit Balance</p>
                                    <img src="/img/spinner.gif" />
                                </div>
                                <div v-show="this.gotData">
                                    <div
                                        v-if="this.error.message"
                                        class="text-center align-self-center"
                                    >
                                        <h4>{{ error.heading }}</h4>
                                        <p>{{ error.message }}</p>
                                    </div>
                                    <div v-else class="text-center">
                                        <p class="sau-pm-reset">Current Credit Balance</p>
                                        <p
                                            class="sau-pm-reset"
                                            style="font-size:40px;"
                                        >{{ creditBalance | currency }}</p>
                                        <b-btn
                                            v-b-modal.modalAddCredit
                                            class="btn btn-sm btn-success"
                                        >Add Credit</b-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" style="height:30px">&nbsp;</div>
                </div>
                <div class="col-sm-12 col-lg-5 align-self-center order-1 order-lg-2">
                    <h3>Add credit to your account</h3>
                    <p>Credit can be added to your Servers Australia account. The amount added will be debited from your Credit Card on file and the amount credited to your next issued invoice.</p>
                </div>
            </div>
        </div>
        <!-- Add Credit Modal -->
        <b-modal
            id="modalAddCredit"
            centered
            title="Add credit to your account"
            @ok="addCredit"
            :ok-disabled="validCreditAmount"
            ok-variant="success"
            ok-title="Add credit"
            cancel-variant="link"
            ref="modalShowAddCredit"
        >
            <form @submit.prevent="addCredit">
                <div class="row">
                    <div class="col-sm-12 col-lg-6 offset-lg-3">
                        <div class="form-group">
                            <label for="credit-amount">Add Credit Amount</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-usd input-icon px-1"></i>
                                    </div>
                                </div>
                                <vue-numeric
                                    id="credit-amount"
                                    name="credit-amount"
                                    v-model="creditAmount"
                                    class="form-control form-control-lg"
                                    v-on:input="$v.creditAmount.$touch"
                                    :class="{'is-invalid': $v.creditAmount.$error, 'is-valid': !$v.creditAmount.$error && this.creditAmount}"
                                    currency
                                    ref="filteredAmount"
                                    :precision="2"
                                ></vue-numeric>
                                <!-- Display errors -->
                                <div class="invalid-feedback">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>
<script>
import { required, numeric, between } from 'vuelidate/lib/validators';
import sauFunctions from '@js/store/sauFunctions'; // contains vuex mapGetters, mapState and mapMutations
export default {
    mixins: [sauFunctions],
    data() {
        return {
            creditAmount: '',
            creditBalance: '',
            error: {
                heading: '',
                message: ''
            },
            gotData: false
        };
    },
    validations: {
        creditAmount: {
            required
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getCreditBalance().then(response => {
                switch (response.data.status.toLowerCase()) {
                    case 'success':
                        /** Check if credit field is supplied - otherwise there may have been an error (missing clientid etc) */
                        if (response.data.data.credit) {
                            this.creditBalance = response.data.data.credit;
                        } else {
                            this.error.heading = 'Whoops!';
                            this.error.message =
                                'We were unable to retrieve your current credit balance';
                        }
                        break;
                    case 'unauthorised':
                        this.error.heading = 'Not Authorized';
                        this.error.message =
                            'You do not have permissions to view the current credit balance';
                        break;
                    default:
                        this.error.heading = 'Whoops!';
                        this.error.message =
                            'We were unable to retrieve your current credit balance';
                        break;
                }
            });
        },
        modalShow() {
            return this.$refs.modalShowAddCredit.show();
        },
        addCredit() {
            /** Add data to available credit */
            window.location =
                '/payment/add-credit/' + parseFloat(this.creditAmount);
        }
    },
    computed: {
        validCreditAmount() {
            return parseFloat(this.creditAmount) < 1;
        }
    }
};
</script>
